import RankingEvents from "./ranking-events";

export default RankingEvents;
